import logo1 from "../assets/logo-1.svg";
import logo2 from "../assets/logo-2.svg";
import logo3 from "../assets/logo-3.svg";
import logo4 from "../assets/logo-4.svg";
import logo5 from "../assets/logo-5.svg";
import logo6 from "../assets/logo-6.svg";

const logos = [logo1, logo2, logo3, logo4, logo5, logo6];

const ClientLogos = () => {
  return (
    <div className="mx-auto grid w-2/4 max-w-xs grid-cols-6 gap-md md:w-5/6 md:max-w-xl lg:w-full lg:gap-x-xl">
      {logos.map((logo, index) => (
        <div
          key={index}
          className="col-span-2 flex items-end justify-center md:col-span-1"
        >
          <img
            className="w-full rounded-2xl object-contain shadow-2xl"
            key={index}
            style={{ width: 86 }}
            src={logo}
            alt=""
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
};

export default ClientLogos;
